<div class="mt-8 flex justify-center paggenat px-4">
	<p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
		[showFirstLastIcon]="false" [showCurrentPageReport]="true"
		[pageLinkSize]="pageLinkSize"
		[currentPageReportTemplate]="currentLang === 'en' ? 'Showing {totalRecords} items' : 'عرض {totalRecords} عنصر'">
	</p-paginator>
</div>